package one.healthium.login.navigation.login

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.ComponentContext
import one.healthium.decompose.viewModelStoreOwner
import one.healthium.domain.user.UserModel

class DefaultSignInComponent(
    componentContext: ComponentContext,
    private val onBackClicked: () -> Unit,
    private val onUserSignedIn: (UserModel) -> Unit,
) : SignInComponent, ComponentContext by componentContext, ViewModelStoreOwner by componentContext.viewModelStoreOwner() {
    override fun onBackClicked() {
        onBackClicked.invoke()
    }

    override fun onUserSignedIn(user: UserModel) {
        onUserSignedIn.invoke(user)
    }
}